import Component from 'vue-class-component'
import moduleStore from '../store/index';
import Vue from 'vue';
import PageState from '../store/state';
import { judgeDeviceType } from "@/utils/device";
import { getQueryString } from "@/utils/location";
import { toAppLoginParams, toNewPage } from '@/utils/utils';
import { uploadImageToOss } from '@/views/videoEditor/utils/utils';
import to from 'await-to-js';
import { saveDataStorage } from '../utils/saveDataStorage';
import {
  toast
} from '@/utils/util'

@Component({})
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames
})
export default class SmartClip extends Vue {
  state = new PageState();

  // 分类
  tabList = [
    {
      name: '短视频链接',
      type: 'link'
    },
    {
      name: '视频文件MP4',
      type: 'mp4'
    },
  ]
  // 当前类型
  activeTabType = 'link'
  link = '';
  uploadRef = null
  // 文件信息
  fileInfo = null
  // 是否上传中
  isUpload = false
  isApp = judgeDeviceType.isAPP;
  percentage = 0; // 文案提取进度
  isSubmiting = false;
  // 是否显示重新上传
  get showRestBtn() {
    if (this.fileInfo && this.activeTabType === 'mp4') {
        return true
    }
    return false
  }

  mounted() {
    (window as any).getAppClipBordContent = this.getAppClipBordContent;
    this.getLocalStorageLink(); // app登录完成跳转回来回填内容
    (window as any)?.setTitle?.postMessage('1/4 解析视频');
    setTimeout(() => {
      this.uploadRef = this.$refs.uploadRef as any;
      console.log('uploadRef', this.uploadRef);
    }, 800)
  }
  destroyed() {
    const video = document.getElementById('video-tutorial') as HTMLVideoElement;
    video?.pause();
  }
  /**
   * 切换tab
   * @param type
   */
  changeTab(type: string) {
    if (this.isSubmiting) return;
    this.activeTabType = type
  }
  handleSelectClick() {
    if (this.isSubmiting) return;
    this.uploadRef.click()
  }
  /**
   * 选择文件
   * @param e
   */
  changeFile(e) {
    const file = e.target.files[0]
    const maxLength = 300 * 1024 * 1024
    if (file.size > maxLength) {
     toast('请上传大小不超过300M的视频文件')
     return
    }
    this.isUpload = true
    file.sizeDesc = (file.size / 1024 / 1024).toFixed(2) + 'M'
    this.loadVideo(file)
    this.uploadRef.value = ''
   }
  // 提供给 app 的粘贴回调
  getAppClipBordContent(message: string) {
    message = decodeURI(message) || '';
    if (!message) return;
    this.setLink(this.link + message);
  }
  // 点击粘贴按钮
  async pasteTxt() {
    if (this.isSubmiting) {
      return toast('正在生成中，请稍后再试');
    }
    if (this.isApp) {
      let getClipBordContent: any = (<any>window).getClipBordContent;
      getClipBordContent.postMessage('');
    } else {
      try {
        const cptext = await navigator.clipboard.readText();
        this.setLink(this.link + cptext);
      } catch (error) {
        toast("请点击输入框，长按粘贴内容");
        console.log('粘贴出错:', error);
      }
    }
  }

  setLink(text) {
    this.link = text;
  }

  getLocalStorageLink() {
    const data = JSON.parse(localStorage.getItem('smartClipData'));
    if (data && data.type) {
      this.activeTabType = data.type;
      this.link = data.link;
      localStorage.removeItem('smartClipData');
    }
  }
  /**
   * 加载视频信息
   */
  loadVideo(file) {
    const video = document.createElement('video')
    video.preload = 'metadata'
    video.src = URL.createObjectURL(file)
    video.onloadedmetadata = () => {
        window.URL.revokeObjectURL(video.src) // 释放URL对象
        file.durationDesc = this.handleDuration(video.duration)
        file.duration = video.duration *  1000;
        file.width = video.videoWidth;
        file.height = video.videoHeight;
        this.fileInfo = file
        let timer = setTimeout(() => {
            this.isUpload = false
            clearTimeout(timer)
            timer = null
        }, 1000)
        
    }
  }
  handleDuration(duration) {
    if (duration < 60) {
        return duration + '秒'
    } else if (duration >= 60 && duration < 3600) {
        return Math.floor(duration / 60) + '分' + Math.floor(duration % 60) + '秒'
    } else {
        return Math.floor(duration / 3600) + '小时' + Math.floor((duration % 3600) / 60) + '分' + Math.floor(duration % 60) + '秒'
    }
  }
  videoTutorialDialog = false;
  confirmClick() {
    console.log('confirmClick');
    this.videoTutorialDialog = false;
    this.videoUrl = '';
    this.coverUrl = '';
    const video = document.getElementById('video-tutorial') as HTMLVideoElement;
    video.pause();
  }
  videoUrl = '';
  coverUrl = '';
  async toVideoTutorial() {
    const [err, res] = await to(this.$http('videoTutorial'))
    if (err || res.code !== 200 || !res.data) {
      return;
    }
    if (res.data[0]) { 
      const { videoUrl, coverUrl } = res.data[0];
      this.videoUrl = videoUrl;
      this.coverUrl = coverUrl;
      this.videoTutorialDialog = true;
      const video = document.getElementById('video-tutorial') as HTMLVideoElement;
      video.play();
    }
  }
  doLogin() {
    if (this.isApp) {
      const timestamp = new Date().getTime() + '';
      const data = { timestamp, type: this.activeTabType, link: this.link };
      localStorage.setItem('smartClipData', JSON.stringify(data));
      toAppLoginParams({ timestamp });
    } else {
      this.$navigateTo({
        url: `/pages/login/login`
      })
    }
  }

  // 提交之前校验函数
  verify() {
    // 没有填写链接或上传文件
    if ((this.activeTabType === 'link' && !this.link) || (this.activeTabType === 'mp4' && !this.fileInfo)) {
      toast('请先输入视频链接或上传视频文件');
      return false;
    }    
    // 链接格式不对
    // if (this.activeTabType === 'link' && !/^(https?:\/\/)?([\w-]+\.)+[\w-]+(\/[\w-./?%&=]*)?$/.test(this.link)) {
    //   toast('链接格式不支持，请确认或更换链接后重试');
    //   return false;
    // }
    
    return true;
  }

  // 获取视频url
  linkData = { url: '', link: ''};
  async extractLink() {
    if (this.link === this.linkData.link && this.linkData.url) return this.linkData.url;

    const [err, res] = await to(this.$http('extractShareLink', {
      url: this.link
    }))
    if (err || res.code !== 200 || !res.data) {
      toast('链接解析失败，请确认或更换链接后重试');
      return;
    }
    const { download: url,  duration, length: size, width, height } = res.data;
    // 校验 解析视频链接时长不超过20min
    if (duration / 1000 > 20 * 60) {
      toast('请输入时长小于20min的视频链接');
      return;
    }
    this.saveSmartClipData({ url, duration, size, width, height });
    this.linkData = { url, link: this.link };
    return url;
  }

  fileData = { url: '', fileInfo: null};
  async uploadFile() {
    if (this.fileInfo === this.fileData.fileInfo && this.fileData.url) return this.fileData.url;

    const [uploadError, url] = await to(uploadImageToOss(this.fileInfo));
    if(uploadError || typeof url !== 'string') {
      toast('图片上传失败');
      return;
    }
    const { duration, size, width, height } = this.fileInfo
    this.saveSmartClipData({ url, duration, size, width, height });
    this.fileData = { url, fileInfo: this.fileInfo };
    return url;
  }
  saveSmartClipData(videoInfo) {
    const data = {
      source: this.activeTabType === 'link' ? 'LINK' : 'FILE', //LINK,FILE
      video: videoInfo
    }
    data.video.duration = Math.floor(data.video.duration);
    saveDataStorage('step1', data);
  }


  // 提交进入下一步
  async doSubmit() {
    const ww_token = localStorage.getItem('ww_token');
    if (!ww_token) return this.doLogin();

    if (!this.verify())  return;

    // 获取视频url
    this.percentage = 0;
    this.isSubmiting = true;
    const url = await (this.activeTabType === 'link' ? this.extractLink() : this.uploadFile())
    this.isSubmiting = false;
    if (!url) return;

    // 创建任务，获取任务id
    this.isSubmiting = true;
    const [taskError, taskData] = await to(this.$http('translateTaskCreate', {
      paramsBean: { source_video_url: url }
    }));
    const taskId = taskData && taskData.data;
    this.isSubmiting = false;
    if (taskError || taskData.code !== 200 && !taskId) {
      toast( taskData.message || '创建任务失败');
      return;
    }

    // 查询任务状态
    this.isSubmiting = true;
    this.getGenerateResult(taskId);
  }

  generateTimer = null
  // 查询任务状态
  async getGenerateResult(id) {
    clearTimeout(this.generateTimer);
    const [generateError, generateRes] = await to(this.$http('getTranslateTaskDetail', {
      taskId: id
    }));
    if (generateError || generateRes.code !== 200) {
      toast(generateRes.message || '查询视频解析状态失败');
      return this.isSubmiting  = false;
    }
    const generateData = generateRes && generateRes.data || {};
    const percentAll = 53.846
    this.percentage = +((generateData.percentage || 0) / percentAll * 100).toFixed(1);
    if(generateData.state === 'RUNNING') { // 运行中
      this.generateTimer = setTimeout(() => {
        this.getGenerateResult(id);
      }, 3000);
      return;
    }
    if(generateData.state !== 'PAUSED') { // FAILED
      toast(generateData.error_message || '视频解析失败');
      return this.isSubmiting  = false;
    }
    // if(generateData.state !== 'PAUSED') return;

    // 完成后获取视频地址和segments
    const parameters = generateData.parameters || [];
    const data = {
      taskId: id,
      source_video_url: '',
      universal_segments: []
    }
    parameters.forEach(item => {
      if(item.name === 'source_video_url') {
        data.source_video_url = item.value;
      }
      if(item.name === 'universal_segments') {
        data.universal_segments = JSON.parse(item.value);
      }
    });
    if(!data.source_video_url || !data.universal_segments.length) {
      toast('获取视频解析结果失败');
      return this.isSubmiting  = false;
    }
    saveDataStorage('step2', data);
    toNewPage('smart-clip-step2');
  }
}